import {payloadLogin} from '@/store/modules/authentication/actions';

const tokenKey: string = 'token';
const userNameKey: string = 'username';

export class UserSessionStorageService {
  public static get user(): payloadLogin {
    
    const token = sessionStorage.getItem(tokenKey);
    const userName = sessionStorage.getItem(userNameKey);

    if (!token || !userName)
      return {} as payloadLogin;

    return {token, username: userName, email: userName};
  }

  public static set user(obj: payloadLogin) {
    const {username, email, token} = obj;
    const userNameConsolidated = email || username;

    sessionStorage.setItem(tokenKey, token);
    sessionStorage.setItem(userNameKey, userNameConsolidated);
  }
}
